import DashboardChart from './DashboardChart';
import { useEffect, useRef, useState } from 'react';
import { useDashboardContext } from './Context';
import { DashboardService } from './service';
import moment from 'moment/moment';

const service = new DashboardService();

export const ChatsConclusoesMes = () => {
    const [loading, setLoading] = useState(false);
    const { selectedDate, atendenteId } = useDashboardContext();
    const competence = moment(selectedDate).format('YYYY-MM');
    const previousCompetenceRef = useRef(competence);

    const [state, setState] = useState<any>({
        series: [
            {
                name: 'Concluídos',
                data: [],
            },
        ],
        options: {
            chart: {
                id: 'area',
                type: 'area',
                zoom: {
                    enabled: false,
                },
            },
            subtitle: {
                text: `Competência: ${moment(competence).format('MMMM [de] YYYY')}`,
                align: 'left',
                margin: 0,
                offsetX: 0,
                offsetY: 0,
                floating: false,
                style: {
                    fontSize: '13px',
                },
            },
            dataLabels: {
                enabled: false,
            },
            markers: {
                size: 0,
                style: 'hollow',
            },
            xaxis: {
                type: 'datetime',
                labels: {
                    format: 'dd/MM/yyyy',
                },
            },
            tooltip: {
                x: {
                    format: 'dd/MM/yyyy',
                },
            },
            colors: ['#007aff'],
            fill: {
                type: 'gradient',
                gradient: {
                    shadeIntensity: 1,
                    opacityFrom: 0.16,
                    opacityTo: 0.02,
                    stops: [0, 100],
                },
            },
        },
    });

    useEffect(() => {
        const fetchData = async (competence: string, atendenteId?: string) => {
            if (!loading) {
                try {
                    setLoading(true);

                    await service.getConclusoesCompetence(competence, atendenteId).then((response) => {
                        const transformedData = response.data.map((item: any) => [
                            new Date(item.date).getTime(),
                            item.count,
                        ]);

                        setState((prevState: any) => {
                            prevState.options.subtitle.text = `Competência: ${moment(competence).format('MMMM [de] YYYY')}`;

                            return {
                                ...prevState,
                                series: [
                                    {
                                        ...prevState.series[0],
                                        data: transformedData,
                                    },
                                ],
                            };
                        });
                    });
                } catch (e) {
                    console.error('Erro ao buscar dados:', e);
                } finally {
                    setTimeout(function (){
                        setLoading(false);

                        if (previousCompetenceRef.current !== competence) {
                            fetchData(previousCompetenceRef.current);
                        }
                    }, 300)
                }
            }
        };

        previousCompetenceRef.current = competence;
        fetchData(competence, atendenteId);
    }, [competence, atendenteId]);

    return (
        <div id="chart" className={`${loading && 'opacity-30 cursor-not-allowed'}`}>
            <DashboardChart
                key={state.options.subtitle.text}
                options={state.options}
                series={state.series}
                type="area"
                height={350}
            />
        </div>
    );
};
